import { createContext, Fragment, useContext, useState } from "react";
import {useNavigate} from "react-router-dom";
import { getRequest } from "utils/request";
import {initialState} from "./constant";

const DashboardContext = createContext(initialState)

const DashboardProvider = ({ children }) => {

  const navigate = useNavigate()
  const [state, setState] = useState(initialState)

  const updateState = (newState) => {
    setState((prevState) => ({
      ...prevState,
      ...newState
    }));
  }

  const fetchData = async (type = "recent_sales") => {
    switch (type) {
      case "total_expenses":
        await fetchTotal("total_expenses")
        break;
      case "total_pullouts":
        await fetchTotal("total_pullouts")
        break;
      case "total_payments":
        await fetchTotal("total_payments")
        break;
      case "total_sales":
        await fetchTotal("total_sales")
        break;
      case "counts":
        await fetchCounts()
        break;
      case "chart_expenses":
        await fetchChartExpenses()
        break;
      case "chart_sales":
        await fetchChartSales()
        break;
      case "recent_sales":
        await fetchRecentSales()
        break;
    }
  }

  const fetchRecentSales = async () => {
    updateState({ is_loading_recent_sales: true })

    let params = `?branch_id=${state.branch_id}`
    params += `&user_id=${state.user_id}`

    let res = await getRequest(`/api/fetch-dashboard${params}`)

    if(res.ok) {
      updateState({
        recent_sales: res.data,
        is_loading_recent_sales: false
      });
    } else {
      updateState({ is_loading_recent_sales: false })
    }
  }

  const fetchTotal = async (type) => {
    updateState({ [`is_loading_${type}`]: true })

    let url = `/api/fetch-dashboard?type=${type}`
    url += `&date=${state[`${type}_date`]}`
    url += `&branch_id=${state.branch_id}`

    let res = await getRequest(url)

    if(res.ok) {
      updateState({
        [type]: res.data,
        [`is_loading_${type}`]: false
      });
    } else {
      updateState({ [`is_loading_${type}`]: false })
    }
  }

  const fetchCounts = async () => {
    updateState({ is_loading_counts: true });

    let params = `?type=counts`
    params += `&branch_id=${state.branch_id}`

    let res = await getRequest(`/api/fetch-dashboard${params}`)

    if(res.ok) {
      updateState({ counts: res.data });
    }

    updateState({ is_loading_counts: false });
  }

  const fetchChartExpenses = async () => {
    updateState({ is_loading_chart_expenses: true });

    let params = `?type=chart_expenses`
    params += `&branch_id=${state.branch_id}`

    let res = await getRequest(`/api/fetch-dashboard${params}`)

    if(res.ok) {
      updateState({chart_expenses: res.data });
    }
    updateState({ is_loading_chart_expenses: false });
  }

  const fetchChartSales = async () => {
    updateState({ is_loading_chart_sales: true });

    let params = `?type=chart_sales`
    params += `&branch_id=${state.branch_id}`

    let res = await getRequest(`/api/fetch-dashboard${params}`)

    if(res.ok) {
      updateState({ chart_sales: res.data });
    }

    updateState({ is_loading_chart_sales: false });
  }

  return (
    <DashboardContext.Provider value={{
      state,
      navigate,
      updateState,
      fetchData,
      fetchTotal
    }}>
      <Fragment>
        {children}
      </Fragment>
    </DashboardContext.Provider>
  )
}

const useDashboardContext = () => {
  const context = useContext(DashboardContext);
  if(!context) {
    throw new Error("useDashboardContext must be used within DashboardProvider")
  }
  return context;
}

export {DashboardProvider, useDashboardContext}
